// Module
var code = "<div class=\"custom-dropdown\"> <select class=\"select\" id=\"vm.id\" ng-model=\"vm.model\" ng-change=\"vm.onChange({value: vm.model})\" ng-options=\"item.taxYearId as item.taxYearName for item in vm.options\" required> </select> </div> ";
// Exports
module.exports = code;